const prod = {
  url: {
    API_URL: "https://portal-api.partsnet.ca/api/",
  },
};

const dev = {
  url: {
    API_URL: "http://localhost:8000/api/",
  },
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
